import { render } from "./MediaSlotReactions.vue?vue&type=template&id=65b8b210&scoped=true&lang=pug"
import script from "./MediaSlotReactions.vue?vue&type=script&lang=js"
export * from "./MediaSlotReactions.vue?vue&type=script&lang=js"

import "./MediaSlotReactions.vue?vue&type=style&index=0&id=65b8b210&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b8b210"]])

export default __exports__